import { enforceUnit } from '../utils'

import type { CSSProperties } from 'vue'
import type { AnyColumns } from '../types'

export const calcColumnStyle = (
  column: AnyColumns[number],
  fixedColumn: boolean,
  fixed: boolean
): CSSProperties => {
  const flex = {
    flexGrow: 0,
    flexShrink: 0,
    ...(fixed
      ? {}
      : {
          flexGrow: column.flexGrow || 0,
          flexShrink: column.flexShrink || 1,
        }),
  }

  if (!fixed) {
    flex.flexShrink = 1
  }

  const style = {
    ...(column.style ?? {}),
    ...flex,
    flexBasis: 'auto',
    width: column.width,
  } as CSSProperties

  if (!fixedColumn) {
    if (column.maxWidth) style.maxWidth = column.maxWidth
    if (column.minWidth) style.minWidth = column.minWidth
  }

  // 把单位转换前置到列阶段，避免每次 cell/header-cell 渲染都重复跑 enforceUnit
  return enforceUnit(style)
}
